import { ToggleButton, ToggleButtonProps, useTheme } from '@mui/material';

interface DashboardToggleTimeButtonProps extends ToggleButtonProps {
  text: string;
}

export const DashboardToggleTimeButton = ({
  text,
  ...toggleButtonProps
}: DashboardToggleTimeButtonProps) => {
  const theme = useTheme();

  const styles = {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(2),
    border: 'none',
    paddingX: theme.spacing(3),
    paddingY: theme.spacing(1.5),
    '&.MuiButtonBase-root:hover': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2) + '!important',
      border: `1px solid ${theme.palette.grey[100]}`,
    },
  };

  return (
    <ToggleButton sx={styles} {...toggleButtonProps}>
      {text}
    </ToggleButton>
  );
};
